import React from 'react';

import Box from '@tds/core-box';
import Heading from '@tds/core-heading';
import Text from '@tds/core-text';

const Success = () => {
  return (
    <div style={{ textAlign: 'center', height: '800px' }}>
      <Box between={3}>
        <Heading level="h2" tag="h2">
          Thanks You!
        </Heading>
        <Text>
          Thank you for reporting an issue, we have received your request. We
          will review and respond as soon as we`re able to.
        </Text>
      </Box>
    </div>
  );
};

export default Success;
